var _path, _path2, _circle, _path3, _circle2, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.5L17.3564 5.88285C17.44 5.66011 17.355 5.40937 17.1533 5.28329L13.5 3",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.5C20.6374 9.5 22.7032 10.0302 23.3324 10.3814C23.4482 10.446 23.5 10.5745 23.5 10.7071V14.2929C23.5 14.4255 23.4473 14.5527 23.3536 14.6464L22.6464 15.3536C22.5527 15.4473 22.4255 15.5 22.2929 15.5H18C17.7239 15.5 17.5 15.7239 17.5 16V17C17.5 17.2761 17.2761 17.5 17 17.5H11C10.7239 17.5 10.5 17.2761 10.5 17V16C10.5 15.7239 10.2761 15.5 10 15.5H5.5C5.22386 15.5 5 15.2761 5 15V14C5 13.7239 5.22386 13.5 5.5 13.5H14.5",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 18.5,
    r: 1.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49371 6.62407C7.75379 6.36415 8.0038 6.30435 8.24086 6.34647C8.49572 6.39189 8.77302 6.56237 9.0481 6.83744C9.32317 7.11252 9.49366 7.38983 9.53907 7.64468C9.58119 7.88174 9.52139 8.13175 9.26147 8.39184C9.12623 8.52708 9.02408 8.57751 8.95142 8.59278C8.8838 8.60696 8.81332 8.5966 8.72355 8.55135C8.62829 8.50331 8.52226 8.42068 8.39623 8.30276C8.26901 8.18369 8.14201 8.04992 7.98882 7.89672C7.83563 7.74353 7.70185 7.61653 7.58278 7.48931C7.46486 7.36328 7.38223 7.25726 7.33419 7.162C7.28894 7.07222 7.27858 7.00174 7.29276 6.93412C7.30803 6.86146 7.35846 6.75931 7.49371 6.62407Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 18.5,
    r: 1.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8C15.1515 8 14.6554 8.23678 14.5328 8.411C14.4961 8.46301 14.4879 8.53034 14.4642 8.5894L13.6257 10.6857C13.5498 10.8755 13.3659 11 13.1615 11H11C10.7239 11 10.5 11.2239 10.5 11.5V12C10.5 12.2761 10.7239 12.5 11 12.5H14.5",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5L5.7995 11.7995C5.62667 11.6267 5.60413 11.3542 5.74619 11.1553L8 8",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H11.5",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19.58V16.7631C4.5 16.3745 4.07601 16.1344 3.74275 16.3344L1.24275 17.8344C1.09215 17.9247 1 18.0875 1 18.2631V19.58C1 19.8561 1.22386 20.08 1.5 20.08H4C4.27614 20.08 4.5 19.8561 4.5 19.58Z",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.5L17.6 15.56",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMower);
export default __webpack_public_path__ + "static/media/Mower.f3d7bab379821b5d1f8610ba81896313.svg";
export { ForwardRef as ReactComponent };